import { Ajax, findMax } from './common_merchant_list'
cb.define([], function (common) {
  var AA_aa_merchantlist_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
    	  const startOrStop = (args) => {
        let selectedRows;
        if (args.params) {
          if (args.params.index < 0) {
            cb.utils.alert('未选择客户！', 'warning');
            return false;
          }
          selectedRows.push(gridModel.getRow(args.params.index));
        } else {
          selectedRows = gridModel.getSelectedRows();
          if (!selectedRows.length) {
            cb.utils.alert('未选择客户！', 'warning');
            return false;
          }
          let _selectRows;
          // 'merchantExtend!stopstatus' true -> 停用； false->启用
          switch (args.cItemName) {
            case "btnBatchEnable": // 启用 
              _selectRows = selectedRows.filter(v => v['merchantExtend!stopstatus'] === true || v['merchantExtend!stopstatus'] === 'true')
              break;
            case "btnBatchDisable": // 停用
              _selectRows = selectedRows.filter(v => v['merchantExtend!stopstatus'] === false || v['merchantExtend!stopstatus'] === 'false')
              break;
            default:
          }
          if (!_selectRows.length) { //审核未通过
            cb.utils.alert('请选择未' + args.cShowCaption + '状态的客户', 'warning');
            return false;
          }
          selectedRows = _selectRows
        }
        let datas = [];
        let length = selectedRows.length;
        for (let i = 0; i < length; i++) {
          datas.push({
            "id": selectedRows[i]["id"],
            "isCreator": selectedRows[i]["isCreator"],
            "biz": args.cParameter,
            "merchantApplyRangeId": selectedRows[i]["merchantApplyRangeId"]
          });
        }
        Ajax(args, datas, viewmodel)
      }
    	 
    	viewmodel.on("batchenable", function(args) { // 启用
        startOrStop(args)
      });
      
    	viewmodel.on("batchdisable", function(args) { // 停用
        startOrStop(args)
      });
      
    	 const formatter = (viewmodel) => {
       let gridModel = viewmodel.getGridModel();
       gridModel.on('beforeLoad', function(data) {
       if (data.condition.isDistinct) {
       data.isDistinct = true;
     } else {
       if (typeof data.isDistinct === 'boolean') {
        delete data.isDistinct
       }
    }
      delete data.condition.isDistinct
    });
    }
    	formatter(viewmodel);
    	let gridModel = viewmodel.getGridModel();
      gridModel.on('beforeDblClick', (args) => {
        args.carryParams.merchantApplyRangeId = args.rowData.merchantApplyRangeId;
        args.carryParams.isCreator = args.rowData.isCreator;
        args.carryParams.isApplied = args.rowData.isApplied;
        args.ids = {
        // customerId: args.rowData.customerId,
       //   shopId: args.rowData.shopId,
          orgId: args.rowData.createOrg
        }
        // args.carryParams.state = {
        //   iStatus: args.rowData.iStatus,
        //   iUOrderStatus: args.rowData.iUOrderStatus
        // }      
      })            
      viewmodel.on('beforeEdit', (args) => {                
        args.carry.carryParams.merchantApplyRangeId = args.carry.rowData.merchantApplyRangeId;              
        args.carry.carryParams.isCreator = args.carry.rowData.isCreator;                
        args.carry.carryParams.isApplied = args.carry.rowData.isApplied; 
        args.carry.ids = {
          //customerId: args.carry.rowData.customerId,
          //shopId: args.carry.rowData.shopId,
          orgId: args.carry.rowData.createOrg
        }
        // args.carry.carryParams.state= {
        // 	iStatus:args.carry.rowData.iStatus,
        // 	iUOrderStatus:args.carry.rowData.iUOrderStatus
        // }
      })   
    }
  }
  try {
    module.exports = AA_aa_merchantlist_VM_Extend;
  } catch (error) {

  }
  return AA_aa_merchantlist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_merchantlist_VM.Extend.js